module.exports = __webpack_public_path__ + "97f6e2a04f011cb2c7e85bf0dac8026e.pdf";